// Time Calculator
// Wait time estimation and time-related calculations

import { TIME_CONSTANTS } from '../config/constants.js';
import { getActiveSellersCount } from '../services/seller-service.js';

/**
 * Calculate estimated wait time for a customer
 * Uses the "groups of 12 minutes per active seller" algorithm
 *
 * @param {number} queuePosition - Customer's position in queue (1-based)
 * @param {object} sellersData - Object with all sellers data
 * @returns {number} Estimated wait time in minutes
 */
export function calculateWaitTime(queuePosition, sellersData) {
    const activeSellers = Math.max(1, getActiveSellersCount(sellersData));
    const groupNumber = Math.ceil(queuePosition / activeSellers);
    const estimatedWaitTime = groupNumber <= 1 ? 0 : (groupNumber - 1) * TIME_CONSTANTS.MINUTES_PER_GROUP;

    return estimatedWaitTime;
}

/**
 * Calculate how long a customer has been waiting
 *
 * @param {Date|Timestamp} createdAt - When customer registered
 * @returns {number} Wait time in minutes
 */
export function calculateActualWaitTime(createdAt) {
    if (!createdAt) return 0;

    const registrationTime = createdAt.toDate ? createdAt.toDate() : new Date(createdAt);
    const waitTimeMs = new Date() - registrationTime;
    const waitTimeMinutes = Math.round(waitTimeMs / 60000);

    // Cap display at 999+ minutes
    return waitTimeMinutes > 999 ? 999 : waitTimeMinutes;
}

/**
 * Format time for display (capped at 999)
 *
 * @param {number} minutes - Time in minutes
 * @returns {string} Formatted time string
 */
export function formatWaitTime(minutes) {
    return minutes > 999 ? '999+' : minutes.toString();
}

/**
 * Format registration time to HH:MM format
 *
 * @param {Date|Timestamp} createdAt - Registration timestamp
 * @returns {string} Formatted time string (e.g., "14:30")
 */
export function formatRegistrationTime(createdAt) {
    if (!createdAt) return '--:--';

    const time = createdAt.toDate ? createdAt.toDate() : new Date(createdAt);
    return time.toLocaleTimeString('es-CL', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
}
